import Slider from 'react-slick'
import styled, { css } from 'styled-components'
import { theme } from '@/client/components'
import breakpoint from '@/client/components/theme/breakpoint'
const { color, space } = theme

export const ProductInfos = styled.div`
  position: relative;
  padding-top: ${space.xl5};
  background-color: ${color.grayscale.light};
  overflow: hidden;
`

export const SideImageAndTextAligner = styled.div`
  .left-side-image,
  .right-side-image {
    display: none;
  }

  @media (min-width: ${breakpoint.xl}) {
    display: flex;
    flex-direction: row;
    justify-content: space-between;

    .left-side-image,
    .right-side-image {
      display: block;
    }

    .content {
      width: 55%;
    }
  }

  @media (min-width: ${breakpoint.xl2}) {
    .content {
      width: 65%;
    }
  }

  @media (min-width: ${breakpoint.hd}) {
    .content {
      width: 70%;
    }
  }
`

export const Contents = styled.div<{ $defaultLocale?: string }>`
  position: relative;
  & p {
    ${({ $defaultLocale }) =>
      $defaultLocale === 'it' &&
      css`
        color: ${color.primary.darker};
      `}
  }

  & li {
    ${({ $defaultLocale }) =>
      $defaultLocale === 'it' &&
      css`
        color: ${color.primary.darker};
      `}
  }
`

export const Services = styled.div`
  position: relative;
  z-index: 1;
`

export const ProductDetails = styled.div`
  position: relative;
  z-index: 2;
`

export const ImageCarouselContainer = styled.div`
  display: none;
  margin-bottom: ${space.xl4};

  @media (min-width: ${breakpoint.xl2}) {
    display: block;

    & img {
      width: 390px;
    }

    .activeImage {
      position: relative;
      top: -${space.md};
    }
  }

  @media (min-width: ${breakpoint.hd2}) {
    .activeImage {
      height: 380px;
    }

    & img {
      width: 500px;
      height: 350px;
    }
  }
`

export const ImageArrayContainer = styled.div`
  display: none;

  @media (min-width: ${breakpoint.lg2}) {
    display: flex;
    justify-content: space-around;
  }
`

export const TextAligner = styled.div`
  @media (min-width: ${breakpoint.xl2}) {
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    z-index: 2;

    .text-description {
      width: 68%;
    }
  }
`

export const Background = styled.div<{ height: number; $background_color?: string }>`
  display: block;
  background-color: ${(props) => (props?.$background_color ? props?.$background_color : 'transparent')};
  width: 220%;
  height: ${(props) => props?.height + 50}px;
  position: absolute;
  top: -20px;
  z-index: 1;
  left: -200px;

  @media (min-width: ${breakpoint.hd2}) {
    left: -330px;
  }
`

export const Slide = styled(Slider)`
  display: none;

  @media (min-width: ${breakpoint.xl2}) {
    display: block;
    position: relative;
    width: 145%;
    left: 0;

    & button {
      position: absolute !important;
      top: 20rem;
      left: 60rem;
      cursor: pointer;
      z-index: 2;
      color: #1b1f26;
    }

    .slick-next {
      left: 63rem;
    }
  }

  @media (min-width: ${breakpoint.hd2}) {
    width: 160%;
    left: -6rem;

    & button {
      top: 24rem;
      left: 73rem;
    }

    .slick-next {
      left: 76rem;
    }
  }
`
